import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-post-calc',
  templateUrl: './post-calc.component.html',
  styleUrls: ['./post-calc.component.css']
})
export class PostCalcComponent implements OnInit {
    argType;

    argValue;

    public selectedBgPostCalcMain: string = 'SUM';

    public materialCostLocValButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'postcalcm',
            gotoParms: () => ({
                argtype: this.edit!.argtype,
                argvalue: this.edit!.argvalue
            })
        }
    ];

    public workHoursButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'postcalcm',
            gotoParms: () => ({
                argtype: this.edit!.argtype,
                argvalue: this.edit!.argvalue
            })
        }
    ];

    public edit?: Edit;

    public itemsListPostCalcWorks: Item[] = [];

    constructor(private stateService: StateService, private utility: UtilityService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue) {
            this.edit = (await this.datatask.Post(840, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadWorks() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListPostCalcWorks = await this.datatask.Post(1091, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private recalcMaterialCostLocValTotal() {
        if (!this.edit) return;

        this.edit.material_cost_locval_total = this.utility.parseNumber(this.edit.material_cost_locval) + this.utility.parseNumber(this.edit.material_cost_corr_locval);

        if (!!this.edit.material_cost_locval_total) this.recalcMaterialAmountLocValTotal();
    }

    private recalcMaterialAmountLocValTotal() {
        if (!this.edit) return;

        this.edit.material_amount_locval_total = this.utility.parseNumber(this.edit.material_cost_locval_total) + (this.utility.parseNumber(this.edit.material_cost_locval_total) * (this.utility.parseNumber(this.edit.material_addition_pst) / 100));
    }

    private recalcWorkHoursTotal() {
        if (!this.edit) return;

        this.edit.work_hours_total = this.utility.parseNumber(this.edit.work_hours) + this.utility.parseNumber(this.edit.work_hours_corr);

        if (this.edit?.work_hours_total) {
            this.recalcWorkCostLocVal();
            this.recalcWorkAmountLocVal();

            if (this.edit?.work_hours_total > 0) {
                this.recalcWorkPricePrHourWorkFocus();
            } else {
                this.edit.work_hours_total = 0;
            }
        }
    }

    private recalcWorkCostLocVal() {
        if (!this.edit) return;

        this.edit.work_cost_locval = this.utility.parseNumber(this.edit.work_hours_total) * this.utility.parseNumber(this.edit.work_cost_rate_locval);

        if (this.edit.work_cost_locval) this.recalcWorkMarginAmountLocVal();
    }

    private recalcWorkAmountLocVal() {
        if (!this.edit) return;

        this.edit.work_amount_locval = this.utility.parseNumber(this.edit.work_hours_total) * this.utility.parseNumber(this.edit.work_rate_locval);

        if (this.edit.work_amount_locval) this.recalcWorkMarginAmountLocVal();
    }

    private recalcWorkPricePrHourWorkFocus() {
        if (!this.edit) return;

        if (this.edit.work_hours_total > 0) {
            this.edit.work_price_pr_hour_workfocus = (this.utility.parseNumber(this.edit.amount_order_locval) - this.utility.parseNumber(this.edit.material_cost_locval_total)) / this.utility.parseNumber(this.edit.work_hours_total);
        }
    }

    private recalcWorkMarginAmountLocVal() {
        if (!this.edit) return;

        this.edit.work_margin_amount_locval = this.utility.parseNumber(this.edit.work_amount_locval) - this.utility.parseNumber(this.edit.work_cost_locval);
    }

    private recalcMachineHoursTotal() {
        if (!this.edit) return;

        this.edit.machine_hours_total = this.utility.parseNumber(this.edit.machine_hours) + this.utility.parseNumber(this.edit.machine_hours_corr);

        if (this.edit.machine_hours_total) {
            this.recalcMachineCostLocValTotal();
            this.recalcMachineAmountLocVal();
        }
    }

    private recalcMachineCostLocValTotal() {
        if (!this.edit) return;

        this.edit.machine_cost_locval_total = this.utility.parseNumber(this.edit.machine_hours_total) * this.utility.parseNumber(this.edit.machine_cost_rate_locval);

        if (this.edit.machine_cost_locval_total) this.recalcMachineMarginAmountLocVal();
    }

    private recalcMachineAmountLocVal() {
        if (!this.edit) return;

        this.edit.machine_amount_locval = this.utility.parseNumber(this.edit.machine_hours_total) * this.utility.parseNumber(this.edit.machine_rate_locval);

        if (this.edit.machine_amount_locval) this.recalcMachineMarginAmountLocVal();
    }

    private recalcMachineMarginAmountLocVal() {
        if (!this.edit) return;

        this.edit.machine_margin_amount_locval = this.utility.parseNumber(this.edit.machine_amount_locval) - this.utility.parseNumber(this.edit.machine_cost_locval_total);
    }

    public onChanged(_: string | number, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'material_cost_corr_locval':
                this.recalcMaterialCostLocValTotal();
                break;
            case 'material_cost_locval_total':
                this.recalcWorkPricePrHourWorkFocus();
                break;
            case 'material_addition_pst':
                this.recalcMaterialAmountLocValTotal();
                break;
            case 'work_hours_corr':
                this.recalcWorkHoursTotal();
                break;
            case 'work_rate_locval':
                this.recalcWorkAmountLocVal();
                break;
            case 'machine_hours_corr':
                this.recalcMachineHoursTotal();
                break;
            case 'machine_cost_rate_locval':
                this.recalcMachineCostLocValTotal();
                break;
            case 'machine_rate_locval':
                this.recalcMachineAmountLocVal();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadWorks();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    argtype: string;
    argvalue: string;
    material_cost_locval: string | number;
    work_hours: string;
    work_cost_locval: string | number;
    amount_order_locval: string;
    material_cost_corr_locval: string | number;
    work_hours_corr: string;
    work_hours_total: string | number;
    material_cost_locval_total: string | number;
    headingtext_material: string;
    headingtext_work: string;
    headingtext_machinetime: string;
    machine_hours: string;
    machine_hours_corr: string;
    machine_hours_total: string | number;
    machine_cost_locval_total: string | number;
    material_addition_pst: string | number;
    material_amount_locval_total: string | number;
    work_rate_locval: string;
    work_price_pr_hour_workfocus: string | number;
    work_note: string;
    work_cost_rate: string;
    work_cost_rate_locval: string;
    work_amount_locval: string | number;
    work_margin_amount_locval: string | number;
    material_note: string;
    machine_note: string;
    machine_cost_rate_locval: string;
    machine_rate_locval: string;
    machine_amount_locval: string | number;
    machine_margin_amount_locval: string | number;
}
